import failed from '../../assets/svg/failed.svg';
import waiting from '../../assets/svg/pause.svg';
import printed from '../../assets/svg/printed.svg';

const renderAction = (action) => {
  switch (action) {
    case 'waiting':
      return <div className="circle waiting" />;
    case 'printed':
      return (
        <div className="circle printed">
          <img src={printed} alt="" />
        </div>
      );
    case 'failed':
      return (
        <div className="circle failed">
          <img src={failed} alt="" />
        </div>
      );
    default:
      return (
        <div className="circle pending">
          <img src={waiting} alt="" />
        </div>
      );
  }
};

export const getColumns = () => [
  {
    Header: 'Referencia de seguimiento',
    accessor: 'reference', // accessor is the "key" in the data
    disableSortBy: true,
  },
  {
    Header: 'Núm. etiquetas',
    accessor: 'packages',
    disableSortBy: true,
    textAlign: 'center',
    width: 40,
    Cell: ({ value }) => {
      return value?.length || 0;
    },
  },
  {
    Header: '',
    accessor: 'status',
    disableSortBy: true,
    className: 'virtual-table__td--status',
    width: 20,
    textAlign: 'center',
    Cell: ({ value }) => renderAction(value),
  },
];
